(() => {
 if (window.britberryExplorerLoaded) return;
 window.britberryExplorerLoaded = true;
 const explorers = new Map();
 function setup(scope) {
  scope.querySelectorAll('[data-bb-explorer]').forEach(root => {
   if (root.dataset.ready) return;
   const buttons = [...root.querySelectorAll('[data-bb-crop]')];
   const panels = [...root.querySelectorAll('[data-bb-profile]')];
   function show(id) {
    if (!buttons.some(button => button.dataset.bbCrop === id)) return;
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bbCrop === id)));
    panels.forEach(panel => { panel.hidden = panel.dataset.bbProfile !== id; });
   }
   buttons.forEach(button => button.addEventListener('click', () => {
    show(button.dataset.bbCrop);
    if (location.hash.startsWith('#britberry-explorer-')) history.replaceState(null, '', '#' + button.id);
   }));
   root.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-bb-profile]');
    if (panel) show(panel.dataset.bbProfile);
   });
   if (buttons.length) show(buttons[0].dataset.bbCrop);
   explorers.set(root, {buttons, show});
   root.dataset.ready = 'true';
  });
 }
 function openHash(hash, move = false, smooth = false) {
  if (!hash.startsWith('#britberry-explorer-')) return false;
  for (const [root, {buttons, show}] of explorers) {
   if (!root.isConnected) { explorers.delete(root); continue; }
   const button = buttons.find(item => '#' + item.id === hash);
   if (!button) continue;
   show(button.dataset.bbCrop);
   if (move) {
    const header = document.querySelector('.shopify-section-header-sticky:not(.shopify-section-header-hidden)');
    const nav = document.querySelector('[data-bb-nav]');
    root.style.scrollMarginTop = ((header?.getBoundingClientRect().height || 0) + (nav?.getBoundingClientRect().height || 0) + 24) + 'px';
    button.focus({preventScroll: true});
    root.scrollIntoView({behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant', block: 'start'});
   }
   return true;
  }
  return false;
 }
 setup(document);
 openHash(location.hash);
 if (document.readyState === 'complete') openHash(location.hash, true);
 else window.addEventListener('load', () => openHash(location.hash, true), {once: true});
 document.addEventListener('click', event => {
  const link = event.target.closest('a[data-bb-explorer-link]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
  if (!openHash(url.hash, true, true)) return;
  event.preventDefault();
  history.pushState(null, '', url.hash);
 });
 window.addEventListener('hashchange', () => openHash(location.hash, true));
 document.addEventListener('shopify:section:load', event => { setup(event.target); openHash(location.hash); });
 document.addEventListener('shopify:section:unload', event => {
  for (const root of explorers.keys()) if (event.target.contains(root)) explorers.delete(root);
 });
})();
